/**
 * Declarative field config for onboarding fields embedded in Tools form.
 * Persisted shape includes `step` on each row; the form stores rows without `step`
 * and serializes order on submit.
 */

export const TOOLS_ONBOARDING_HEADER_TEXT_FIELDS = [
    {
        name: 'onboardHeader' as const,
        label: 'Onboarding header',
        placeholder: 'Main headline',
    },
    {
        name: 'onboardSubHeader' as const,
        label: 'Onboarding sub-header',
        placeholder: 'Supporting line under the header',
    },
] as const

export const TOOLS_ONBOARDING_HEADER_IMAGE = {
    name: 'onboardHeaderImage' as const,
    label: 'Header image',
    helpText: 'Upload an image; only the storage path is sent to the API.',
} as const

export const TOOLS_ONBOARDING_CTA_FIELDS = [
    {
        name: 'ctaButtonText' as const,
        label: 'CTA button text',
        placeholder: 'e.g. Get started',
    },
] as const

export const TOOLS_ONBOARDING_STEP_FIELDS = [
    {
        name: 'title' as const,
        kind: 'text' as const,
        label: 'Title',
        placeholder: 'Step title',
    },
    {
        name: 'description' as const,
        kind: 'textarea' as const,
        label: 'Description',
        placeholder: 'Step description',
        rows: 2,
    },
] as const

export function defaultOnboardStepRows(): Array<{
    title: string
    description: string
    icon: string
}> {
    return [{icon: '', title: '', description: '' }]
}

export function onboardStepRowsFromTool(tool: any): Array<{
    icon: string
    title: string
    description: string
}> {
    const raw = tool?.onboardSteps ?? tool?.onboard_steps
    if (!Array.isArray(raw) || raw.length === 0) return defaultOnboardStepRows()
    return [...raw]
        .sort((a, b) => (a.step ?? 0) - (b.step ?? 0))
        .map((s) => ({
            icon: s.icon ?? '',
            title: s.title ?? '',
            description: s.description ?? '',
        }))
}

export function serializeOnboardStepsForApi(
    rows: Array<{ title?: string | null; description?: string | null }>
) {
    return rows.map((row, index) => ({
        step: index + 1,
        title: (row.title ?? '').trim(),
        description: (row.description ?? '').trim(),
    }))
}
